import { render, staticRenderFns } from "./page-8.vue?vue&type=template&id=4fd5fa02&scoped=true&"
import script from "./page-8.vue?vue&type=script&lang=js&"
export * from "./page-8.vue?vue&type=script&lang=js&"
import style0 from "./page-8.vue?vue&type=style&index=0&id=4fd5fa02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd5fa02",
  null
  
)

export default component.exports